// BUILD-042 (Oct 20 final UAT batch) - show a department by its NAME, never as a raw id.
//
// An employment term stores the department's id (stable across renames). Several screens used to print that id. This hook loads every department - ACTIVE AND DISABLED,
// because a person keeps a department that was disabled later and its name must stay readable - and gives the screens an id -> name lookup.
//
// While the list is loading, or if it cannot be read, the lookup returns null and the caller shows its normal "not recorded" wording: it never falls back to printing the id.
import { useEffect, useState } from 'react';
import { listHrDepartments } from '../../api/client';

export interface DepartmentNames {
  /** The department's name, or null when there is no id, the list is not loaded, or the id is unknown. */
  nameOf: (departmentId: string | null | undefined) => string | null;
  loaded: boolean;
}

export function useDepartmentNames(): DepartmentNames {
  const [byId, setById] = useState<Record<string, string> | null>(null);
  useEffect(() => {
    let alive = true;
    listHrDepartments({ includeDisabled: true })
      .then((d) => { if (alive) setById(Object.fromEntries((d.departments ?? []).map((x) => [x.departmentId, x.name]))); })
      .catch(() => { if (alive) setById({}); });
    return () => { alive = false; };
  }, []);
  return {
    nameOf: (id) => (id && byId ? byId[id] ?? null : null),
    loaded: byId !== null,
  };
}
